/* 获取url参数 */
export const getURLParam = (name: any) => {
  const value = window.location.search.match(
    new RegExp('[?&]' + name + '=([^&]*)(&?)', 'i'),
  );
  return value ? decodeURIComponent(value[1]) : value;
}

/* 判断环境拉取数据 */
export const fetchProd: () => boolean = () => {
  const url = window.location.hostname;
  if (url !== 'test-hd.huya.com' && url !== 'testhd.hxm.huya.com' && url !== 'test.hd.huya.com') {
    return true;
  } else {
    if (getURLParam('debug') !== null) {
      return false;
    }
    return true;
  }
}

/* 判断是否H5打开 */
export const isDeviceOpen: () => boolean = () => {
  const device = navigator.userAgent;
  const reg = RegExp(/Android|webOS|iPhone|iPod|BlackBerry/i);
  return reg.test(device);
}